import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from './routes'
import { store } from '../store/store'


Vue.use(VueRouter)

export const router = new VueRouter({
    mode: 'history',
    routes
})

// beforeEach user validate auth


router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.loggedIn) {
            next({
                name: 'login',
            })
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.requiresVisitor)) {
        if (store.getters.loggedIn) {
            next({
                name: 'home',
            })
        } else {
            next()
        }
    } else {
        next()
    }
})


// WEBPACK FOOTER //
// ./src/router/router.js